var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame48095976(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 45,
    height: 45,
    rx: 22.25,
    transform: "rotate(-180 46 46)",
    stroke: "#FFFAE6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9408 32.1688H24.5911V24.859H27.8801L28.2414 21.2269H24.5911V19.3926C24.5911 19.1505 24.6872 18.9184 24.8584 18.7473C25.0295 18.5761 25.2616 18.48 25.5037 18.48H28.2414V14.8296H25.5037C24.2935 14.8296 23.1329 15.3104 22.2772 16.1661C21.4215 17.0218 20.9408 18.1824 20.9408 19.3926V21.2269H19.1156L18.7542 24.859H20.9408V32.1688Z",
    fill: "#FFFAE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48095976);
export default __webpack_public_path__ + "static/media/frame-48095976.b4c88ba23691b327984fccedd4de9803.svg";
export { ForwardRef as ReactComponent };